import { Signal } from './Signal';

export class Reasons<T> {
  public onChange: Signal<boolean> = new Signal();
  private reasons: T[] = [];

  public add(reason: T): void {
    const wasEmpty = this.isEmpty();
    this.reasons.push(reason);
    wasEmpty && this.onChange.dispatch(true);
  }

  public remove(reason: T): void {
    const wasEmpty = this.isEmpty();
    this.reasons = this.reasons.filter((r: T) => r !== reason);
    !wasEmpty && this.isEmpty() && this.onChange.dispatch(false);
  }

  public isEmpty(): boolean {
    return this.reasons.length === 0;
  }
}
